import { HeaderContext } from '../context'
import React, { useCallback } from 'react'

interface UseProviderHeaderHeightHook {
  height: number
  setHeight: (value: number) => void
}

export const useHeaderHeight = (): UseProviderHeaderHeightHook => {
  const contextValue = React.useContext(HeaderContext)

  if (contextValue === undefined) {
    throw new Error('useHeaderheight must be used within HeaderProvider')
  }

  const setHeight = useCallback(
    (value: number): void => {
      contextValue?.setHeight(value)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contextValue.setHeight]
  )

  return { height: contextValue?.height, setHeight }
}
